export interface PriceFromPriceListResponse {
  price: number;
}
